// Logo Upload Component
// Handles firm logo upload and display

import { useRef } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Upload, Loader2, Image as ImageIcon } from 'lucide-react';

const LogoUpload = ({ logoUrl, uploading, onUpload }) => {
  const fileInputRef = useRef(null);

  return (
    <Card className="border-slate-200">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <ImageIcon className="w-5 h-5 text-teal-500" />
          Logo
        </CardTitle>
        <CardDescription>
          Upload your firm&apos;s logo (PNG, JPG, SVG, or WebP, max 2MB)
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {logoUrl ? (
            <div className="relative w-32 h-32 bg-slate-100 rounded-xl flex items-center justify-center overflow-hidden border-2 border-slate-200">
              <img 
                src={`${process.env.REACT_APP_BACKEND_URL}${logoUrl}`}
                alt="Logo" 
                className="max-w-full max-h-full object-contain"
              />
            </div>
          ) : (
            <div className="w-32 h-32 bg-slate-100 rounded-xl flex items-center justify-center border-2 border-dashed border-slate-300">
              <ImageIcon className="w-8 h-8 text-slate-400" />
            </div>
          )}
          
          <input
            type="file"
            ref={fileInputRef}
            onChange={onUpload}
            accept="image/png,image/jpeg,image/svg+xml,image/webp"
            className="hidden"
          />
          
          <Button
            variant="outline"
            onClick={() => fileInputRef.current?.click()}
            disabled={uploading}
            data-testid="upload-logo-btn"
          >
            {uploading ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                Uploading...
              </>
            ) : (
              <>
                <Upload className="w-4 h-4 mr-2" />
                {logoUrl ? 'Change Logo' : 'Upload Logo'}
              </>
            )}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default LogoUpload;
